import { Input } from "@chakra-ui/react";
import { useState, ChangeEvent } from "react";
import {
	dollerValueEIN,
	dollerValueSSN,
	placeHolderValueEIN,
	placeHolderValueSSN,
	regexEIN,
	regexSSN,
} from "utils/constants";

interface MaskInputsProps {
	onChange: (formattedSSN: string) => void;
	fields?: any;
	defaultValue?: any;
	isDisabled?: boolean;
	isInvalid?: boolean;
}

const MaskInputs: React.FC<MaskInputsProps> = ({
	onChange,
	fields,
	defaultValue,
	isDisabled,
	isInvalid,
}) => {
	const [error, setError] = useState(false);
	const [inputValue, setInputValue] = useState(defaultValue || "");

	const getInputPattern = (fields: any) => {
		if (fields.label === "SSN") {
			return regexSSN.pattern;
		} else if (fields.label === "EIN") {
			return regexEIN.pattern;
		}
	};

	const getInputValidation = (fields: any) => {
		if (fields.label === "SSN") {
			return regexSSN.inputValidation;
		} else if (fields.label === "EIN") {
			return regexEIN.inputValidation;
		}
	};

	const getReplacePatternValue = (fields: any) => {
		if (fields.label === "SSN") {
			return dollerValueSSN[0];
		} else if (fields.label === "EIN") {
			return dollerValueEIN[0];
		}
	};

	const getPlaceHolderValue = (fields: any) => {
		if (fields.label === "SSN") {
			return placeHolderValueSSN[0];
		} else if (fields.label === "EIN") {
			return placeHolderValueEIN[0];
		}
	};

	const InputPattern = getInputPattern(fields) ?? "";
	const inputValidation: RegExp = getInputValidation(fields) ?? /(?:)/;
	const replacePattern = getReplacePatternValue(fields) ?? "";

	const formatSSN = (value: string) => {
		const numericValue = value.replace(/\D/g, "");

		const formattedSSN = numericValue.replace(InputPattern, replacePattern); // Format the input pattern
		return formattedSSN;
	};

	const validateInput = (value: string) => {
		const regex = inputValidation;
		return regex.test(value);
	};

	const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
		const inputValue = event.target.value;
		// Validate the input against the regex
		if (validateInput(inputValue)) {
			const formattedSSN = formatSSN(inputValue);
			setInputValue(formattedSSN);
			// Pass the formatted SSN directly to the parent component
			onChange(formattedSSN);
			setError(false);
		} else {
			setError(true);
		}
	};

	return (
		<Input
			value={inputValue}
			onChange={handleInputChange}
			placeholder={getPlaceHolderValue(fields)}
			variant="primary"
			minHeight="2.5rem"
			isInvalid={error || isInvalid}
			isDisabled={isDisabled}
		/>
	);
};

export default MaskInputs;
